<template>
  <a-config-provider :locale="locale">
    <div id="app">
      <a-layout>
        <index-header :class="{'content-page': contentPage}" v-if="!loginHeaderFlag"></index-header>
        <login-header v-else></login-header>
        <a-layout class="main-style">
          <a-layout-content :class="!loginHeaderFlag ? 'main-content': ''" id="mainContent"
                            :style="{minHeight: bodyMinHeight + 'px'}">
            <home-menu v-if="!homeMenuFlag"></home-menu>
            <keep-alive :include="aliveTabs">
              <router-view class="main-content-body" :class="{'has-margin': contentPage}"/>
            </keep-alive>
            <customer-service />
          </a-layout-content>
        </a-layout>
      </a-layout>
      <a-spin class="dol-loading-spin" :spinning="$store.state.loading" size="large" />
    </div>
  </a-config-provider>
</template>

<script>
import zhCN from 'ant-design-vue/lib/locale-provider/zh_CN';
import enUS from 'ant-design-vue/lib/locale-provider/en_US';
import ruRU from 'ant-design-vue/lib/locale-provider/ru_RU'
import dolHeader from './components/common/header';
import dolFooter from './components/common/footer';
import dolSideBar from './components/common/side-bar';
import TheMenuTab from '@/components/common/the-menu-tab';
import HomeMenu from "./components/common/home-menu";
import IndexHeader from "./components/common/index-header";
import IndexFooter from "@/components/common/index-footer";
import LoginHeader from "./components/common/login-header";
import CustomerService from '@/components/contcircle/customer-service.vue';

export default {
  name: 'index',
  components: { CustomerService, LoginHeader, IndexHeader, HomeMenu, TheMenuTab, dolHeader, dolFooter, dolSideBar,IndexFooter },
  data() {
    return {
      bodyMinHeight: 200,
      homeMenuFlag: false,
      loginHeaderFlag: false
    };
  },
  watch: {
    $route(to,from){
      let loginRouteArr = ['login','register','retrievePassword','register','registerDetail','registerSuccess','companyRegister'];
      let homeRouteArr = ['login','register','retrievePassword','companyDetails','index','bulletin','bulletinDetail','notice','orderDetail',
        'register','registerDetail','registerSuccess','companyRegister','statementDetail','helpCenter','helpDetails', 'boxApplyForm', 'aboutUs', 'notFound'];
      this.$nextTick(() =>{
        if(loginRouteArr.indexOf(to.name) != -1){
          this.loginHeaderFlag = true;
        }else {
          this.loginHeaderFlag = false;
        }
        if(homeRouteArr.indexOf(to.name) != -1){
          this.homeMenuFlag = true;
        }else {
          this.homeMenuFlag = false;
        }
      })
    }
  },
  computed: {
    /*homeMenuFlag(){
      this.$nextTick(() =>{
        return this.$route.name === "login" ||
            this.$route.name === "register" ||
            this.$route.name === "index" ||
            this.$route.name === "bulletin" ||
            this.$route.name === "bulletinDetail" ||
            this.$route.name === "retrievePassword" ||
            this.$route.name === "register" ||
            this.$route.name === "registerDetail" ||
            this.$route.name === "registerSuccess" ||
            this.$route.name === "companyRegister" ||
            this.$route.name === "notice" ||
            this.$route.name === "orderDetail"
      });
    },
    loginHeaderFlag(){
      return this.$route.name === "login" ||
        this.$route.name === "register" ||
        this.$route.name === "retrievePassword" ||
        this.$route.name === "register" ||
        this.$route.name === "registerDetail" ||
        this.$route.name === "registerSuccess" ||
        this.$route.name === "companyRegister";
    },*/
    aliveTabs() {
      const res = ['activityOrder', 'historyOrder', 'cancelOrder', 'orderManager', 'boxApply'];
      this.$store.state.menuTab.forEach(m => {
        if (!m.CLASS_NAME) return;
        const arr = m.CLASS_NAME.split('/');
        res.push(arr[arr.length - 1]);
      });
      return res;
    },
    headerFlag() {
      return this.$store.state.userInfo;
    },
    menuFlag() {
      return this.$store.state.userInfo;
    },
    breadcrumbFlag() {
      return this.$store.state.userInfo;
    },
    locale() {
      if(this.$i18n.locale === 'ru'){
        return ruRU
      } else if (this.$i18n.locale === 'en') {
        return enUS
      } else {
        return zhCN
      }
    },
    contentPage(){
      return !/^(\/login|\/|\/index|\/aboutUs)$/.test(this.$route.path);
    },
  },
  methods: {
    pageMinHeight() {
      let header = 64;
      let breadcrumb = 48;
      let mainPadding = 24;
      let footer = 0; //41;
      let pageContentHeight;
      let clientHeight = Math.min(document.body.clientHeight, document.documentElement.clientHeight);

      if (this.$store.state.userInfo) {
        pageContentHeight = clientHeight - (header + breadcrumb + mainPadding + footer);
      } else {
        pageContentHeight = clientHeight - mainPadding;
      }

      this.bodyMinHeight = Math.max(200, pageContentHeight);
    }
  },
  sockets: {
    connect() {

    },
    disconnect() {

    },

    //自定义事件名做为方法名
    message() {

    }
  },
  created() {
    //i18n
    this.$i18n.locale = (navigator.language || navigator.userLanguage).substr(0, 2);
    this.$message.config({
      maxCount: 1,
    })
    const lang = localStorage.getItem("lang");
    if (lang) {
      this.$i18n.locale = lang;
    }
  },
  mounted() {
    setTimeout(() => this.pageMinHeight, 1000);
    window.onresize = this.pageMinHeight;
    // window.onbeforeunload = function (e) {
    //   return '';
    // };
    // $(window).bind("resize", this.pageMinHeight);
  },
};
</script>
<style lang="scss">
@import "./assets/css/quill-font.css";
  .main-style{
    .main-content{
      //width: 1200px;
      //margin: 24px auto;
      display: flex;

      .main-content-body{
        overflow-y: auto;
        flex: 1;

        &.has-margin{
          margin: 20px;
        }
      }
    }
  }
</style>